module.exports = __webpack_public_path__ + "img/Fisherman Gold.c86b69fb.jpg";